import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';
import Icon from 'carbon-react/lib/components/icon';

import * as styles from './styles.scss';

interface SfaFatalErrorProps {
  title: ReactNode;
  subtitle: ReactNode;
  text: ReactNode;
  image: string;
}

export const SfaFatalError = ({ title, subtitle, text, image }: SfaFatalErrorProps) => {
  const intl = useIntl();
  const extraText = {
    help: intl.formatMessage({
      id: 'onboarding.sfa.if_you_need_help',
      defaultMessage: 'If you need help, you can search our Help Centre or email us.'
    }),
    helpCentreLink: intl.formatMessage({
      id: 'onboarding.sfa.help_centre_link',
      defaultMessage: 'Help Centre (opens in a new window)'
    })
  };

  const HELP_EMAIL = 'futrli-help@sage.com';

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
      <Box display="flex" justifyContent="space-between" width="864px" p={4}>
        <Box width="300px">
          <img src={image} alt="" aria-hidden />
        </Box>
        <Box width="430px">
          <Typography variant="h1" mb={3}>
            {title}
          </Typography>
          <Typography variant="h2" mb={1} fontSize="18px">
            {subtitle}
          </Typography>
          <Typography variant="big">{text}</Typography>

          <hr className={styles.divider} />

          <Typography variant="big" mb={3}>
            {extraText.help}
          </Typography>
          <Typography color="--colorsActionMajor500">
            <a
              href="https://support.futrli.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'var(--colorsActionMajor500)' }}
            >
              <Icon mr={1} type="help" fontSize="small" color="--colorsActionMajor500" mt="-2px" />
              <span style={{ textDecoration: 'underline' }}>{extraText.helpCentreLink}</span>
            </a>
          </Typography>
          <Typography color="--colorsActionMajor500">
            <a href={`mailto:${HELP_EMAIL}`} style={{ color: 'var(--colorsActionMajor500)' }}>
              <Icon mr={1} type="email" fontSize="small" color="--colorsActionMajor500" mt="-2px" />
              <span style={{ textDecoration: 'underline' }}>{HELP_EMAIL}</span>
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
